import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'

Vue.prototype.$axios = axios
// axios.defaults.baseURL = 'http://192.168.1.13:8081/';
axios.defaults.baseURL = 'https://betatechgame.com/'

import store from './store/store'
import './style/global.scss'
import './style/reset.css'
import './style/font.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import {Message } from 'element-ui'
Vue.prototype.$Message = Message

Vue.use(ElementUI)
import 'animate.css';
Vue.config.productionTip = false
import router from './router/index'

Vue.directive('animate', {
  inserted: function (el, binding) {
    // 聚焦元素
    binding.addClass = () => {
      const { top } = el.getBoundingClientRect()
      const h = document.documentElement.clientHeight || document.body.clientHeight
      if (top < h) {
        if(el.className.indexOf(binding.value) == -1 ){
          // 下面单引号中间是一个空格
          el.className = binding.value+' '+el.className
        }
        if (binding.addClass) {
          window.removeEventListener('scroll', binding.addClass)
        }
      }
    }
    window.addEventListener('scroll', binding.addClass,true)
    binding.addClass()
  },
  unbind: function (el, binding) {
    if (binding.addClass) {
      window.removeEventListener('scroll', binding.addClass)
    }
  }
})
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')